/**
 *
 * ConfirmModal
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import CloseButton from "basicComponents/CloseButton/CloseButton";
import Modal from "basicComponents/Modal/Modal";
import { Close } from "@material-ui/icons";

function noBubble(e) {
  e.stopPropagation();
}

function InfoModal({ open, onConfirm, children, header }) {
  return (
    <Modal open={open}>
      <Content onClick={noBubble} data-cy="infoModal">
        <Wrapper>
          <HeaderText disableMargin>{header}</HeaderText>
          <ButtonRow>
            <CloseButton id="closeButton" onClick={onConfirm}>
              <Close />
            </CloseButton>
          </ButtonRow>
        </Wrapper>
        <div>{children}</div>
      </Content>
    </Modal>
  );
}

InfoModal.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  header: PropTypes.any,
};

function noop() {}
InfoModal.defaultProps = {
  onConfirm: noop,
};

export default InfoModal;

const Wrapper = styled.div`
  display: flex;

  &:before {
    content: "";
    margin-right: auto;
  }
`;
const HeaderText = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 5px;
`;
const ButtonRow = styled.div`
  margin-left: auto;
`;

const Content = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  border-radius: ${({ theme }) => theme.borderRadius};

  background-color: white;
`;
